import type { HttpPost, HttpRequest } from '@/shared/infra/http'
import type { LegalAcceptanceResult } from '@/shared/domain'
import type {
  RecordLegalAcceptance,
  RecordLegalAcceptanceParams,
} from '@/modules/legal/use-cases'

export class EdgeRecordLegalAcceptanceRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: RecordLegalAcceptance = async (params) => {
    const body = buildBody(params)
    const request: HttpRequest<typeof body> = {
      url: '/legal-documents',
      body,
    }
    return this.httpClient.post<typeof body, LegalAcceptanceResult>(request)
  }
}

function buildBody(params: RecordLegalAcceptanceParams) {
  const body: {
    documentId: string
    acceptanceMethod: string
    userAgent?: string
    ipAddress?: string
  } = {
    documentId: params.documentId,
    acceptanceMethod: params.acceptanceMethod,
  }
  if (params.userAgent !== undefined) body.userAgent = params.userAgent
  if (params.ipAddress !== undefined) body.ipAddress = params.ipAddress
  return body
}
